import { createSlice } from '@reduxjs/toolkit'
import { setAutoFreeze } from 'immer'

setAutoFreeze(false)
const INITIAL_STATE = {
  selectedGroupId: '',
  selectedGroupName: '',
  selectedPropertyId: '',
  selectedPropertyName: '',
  buildingCode: '',
  user: null,
  isCreateBuilding: false,
  // Bumped whenever a building is saved. Building pickers watch it so a save is reflected
  // without a reload — isCreateBuilding cannot do this, it latches true and stops changing.
  buildingsVersion: 0,
  requestsBadgeCount: 0,
  groupDetail: {},
  propertyTag: {
    PropertyTagId: '',
    Name: '',
  },
  selectedManagementTag: {
    TagId: '',
    Name: '',
  },
}

let profileSlice = createSlice({
  name: 'profile',
  initialState: INITIAL_STATE,
  reducers: {
    selectedGroup: function (state, action) {
      // A building belongs to one group: switching groups must drop the old
      // selection, or /b/<bId> links keep pointing at the previous group's
      // building. Callers that pick a new building dispatch selectedProperty
      // right after, so clearing here is always safe.
      //
      // Hydrating from empty is not a switch. Login dispatches this on every
      // sign-in, and with no previous group every login counted as a change —
      // which threw away the persisted building before the launcher could read
      // it. The building bootstrap re-validates what survives against the
      // user's access, so keeping it here is safe.
      if (state.selectedGroupId && state.selectedGroupId !== action.payload.groupId) {
        state.selectedPropertyId = ''
        state.selectedPropertyName = ''
        state.buildingCode = ''
        state.propertyTag = {}
      }
      state.selectedGroupId = action.payload.groupId
      state.selectedGroupName = action.payload.groupName
      state.groupDetail = action.payload.group
      state.isCreateBuilding = false
      state.selectedManagementTag = { TagId: '', Name: '' }
    },
    buildingsChanged: function (state) {
      state.buildingsVersion = (state.buildingsVersion || 0) + 1
    },
    setManagementTag: function (state, action) {
      state.selectedManagementTag = action.payload.managementTag || { TagId: '', Name: '' }
    },
    clearGroup: function (state) {
      state.selectedGroupId = ''
      state.selectedGroupName = ''
      state.groupDetail = {}
      state.isCreateBuilding = false
    },
    selectedProperty: function (state, action) {
      state.selectedPropertyId = action.payload.propertyId
      state.selectedPropertyName = action.payload.propertyName
      state.buildingCode = action.payload.buildingCode
      state.propertyTag = action.payload.propertyTag
      state.isCreateBuilding = action.payload.isCreateBuilding
    },
    setUserData: function (state, action) {
      state.user = action.payload
      state.isCreateBuilding = false
    },
    resetReducer: function () {
      return {
        currentProperty: '',
        currentPropertyId: '',
        selectedGroupId: '',
        selectedGroupName: '',
        selectedPropertyId: '',
        selectedPropertyName: '',
        isCreateBuilding: false,
        buildingsVersion: 0,
        buildingCode: '',
        user: null,
        requestsBadgeCount: 0,
        groupDetail: {},
        selectedManagementTag: {
          TagId: '',
          Name: '',
        },
      }
    },
  },
})

const { reducer: profileReducer } = profileSlice

export const {
  selectedProperty,
  selectedGroup,
  setUserData,
  clearGroup,
  resetReducer,
  setManagementTag,
  buildingsChanged,
} = profileSlice.actions
export default profileSlice.reducer

export { profileReducer }
